import { Button, Checkbox } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import TimeAgo from "@/components/time-ago";
import {
  getDate,
  getEnumNumberValues,
  mapExploitationStageToStringName,
} from "@/lib/common-utils";
import { ExploitationStage } from "@/lib/constants";
import { PlatformServiceRegularDto } from "@/shared/api";

export const useRunningServicesTableColumns = (innerModes: Record<string, number>) => {
  const { t } = useTranslation();

  return useMemo<MRT_ColumnDef<PlatformServiceRegularDto>[]>(
    () => [
      {
        header: t("name"),
        accessorFn: (row) => row.id ?? "-",
        filterFn: "contains",
      },
      {
        header: t("mode"),
        accessorFn: (row) => {
          const actualMode = innerModes[row.id] ? innerModes[row.id] : row.mode;
          const value = getEnumNumberValues(ExploitationStage)
            .filter((item) => item === actualMode)
            .map((item) => ({ label: mapExploitationStageToStringName(item), value: item }))
            .at(0)?.label;

          return `${value} (${actualMode})`;
        },
        filterFn: "contains",
      },
      {
        header: t("serviceType"),
        accessorFn: (row) => row.type ?? "-",
        filterFn: "contains",
      },
      {
        header: t("serverAddress"),
        accessorFn: (row) => row.server_addr ?? "-",
        filterFn: "contains",
      },
      {
        header: t("serverPort"),
        accessorFn: (row) => row.server_port ?? "-",
        filterFn: "contains",
        size: 100,
      },
      {
        header: t("updatedAt"),
        accessorFn: (row) => getDate(row.updated_at) ?? "-",
        filterFn: "contains",
        size: 140,
      },
      {
        header: t("uptime"),
        accessorFn: (row) => (row.uptime ? <TimeAgo pastDate={row.uptime} /> : "-"),
        filterFn: "contains",
      },
      {
        header: t("nClients"),
        accessorFn: (row) => row.nclients ?? 0,
        filterFn: "contains",
      },
      {
        header: t("nThreads"),
        accessorFn: (row) => row.nthreads ?? 0,
        filterFn: "contains",
      },
    ],
    [t, innerModes]
  );
};
